"use strict";

define('app/reporting/audit.reporting.controller',['app/reporting/audit.reporting.view', 'rs/abstract.content.controller', 'rs/services/report.service', 'e3-table'], function (AuditReportingView, AbstractContentController, ReportService, E3Table) {
  var AuditReportingController = AbstractContentController.extend({
    contentName: 'audit-reporting-content abstract-content fixed-header off-white',
    properties: ['reportService', 'reportTable'],
    reportColumns: [{
      displayName: 'Name',
      name: 'name',
      type: 'String',
      width: '25%'
    }, {
      displayName: 'Author',
      namespace: 'author.displayName',
      type: 'String',
      width: '15%'
    }, {
      displayName: 'Created On',
      name: 'createDate',
      type: 'Date',
      width: '15%'
    }, {
      displayName: 'Modified On',
      name: 'modifiedDate',
      type: 'Date',
      width: '15%'
    }, {
      displayName: 'Last Run',
      name: 'lastRunDate',
      type: 'Date',
      width: '15%'
    }, {
      displayName: 'Actions',
      name: 'actions',
      width: '15%'
    }],
    initialize: function initialize() {
      this._super.apply(this, arguments);
      this.setReportService(new ReportService());
      this.getReportService().configure({
        reportTypeName: 'IRB_Audit'
      });
      this.setReportTable(new E3Table.AccordionController(this.getReportTableOptions()));
      this.registerTableController(this.getReportTable());
    },
    createNewReportDefinition: function createNewReportDefinition() {
      this.getAppController().navigateReport({}, {
        trigger: true
      });
    },
    deleteReportDefinition: function deleteReportDefinition(report) {
      return this.getReportService().deleteReportDefinition(report).bind(this).then(function () {
        return this.getReportTable().refresh();
      });
    },
    editReportDefinition: function editReportDefinition(report) {
      this.getAppController().navigateReport(report, {
        trigger: true
      });
    },
    runReport: function runReport(report) {
      this.getReportService().runReportDefinition(report);
    },
    getReportTableOptions: function getReportTableOptions() {
      return {
        columns: this.reportColumns,
        delegate: this,
        selectable: false,
        theme: 'rs'
      };
    },
    getTemplateProperties: function getTemplateProperties() {
      return {
        modifyPermission: this.isAbleToModifyReport()
      };
    },
    isAbleToModifyReport: function isAbleToModifyReport() {
      return this.checkPermission('MODIFY_REPORT');
    },
    setupView: function setupView() {
      this.setView(new AuditReportingView());
    },
    start: function start() {
      return this.getReportService().load('type').bind(this).then(function () {
        this.getView().render();
      });
    },
    viewIsAvailable: function viewIsAvailable() {
      this.getReportTable().setup(this.getView().getReportTableContainer());
      this.getReportTable().start();
      this._super.apply(this, arguments);
    },
    requestFilterText: function requestFilterText(text) {
      this.getReportTable().setFilter(text);
    },
    getData: function getData() {
      return this.getReportService().getReports();
    },
    isTableItemSelectable: function isTableItemSelectable() {
      return false;
    },
    processTableItemCell: function processTableItemCell(cell, item, column, table) {
      if (column.name == 'actions') {
        cell.content = this.getView().getReportCellContent();
      }
      return cell;
    },
    processFilter: function processFilter(items, filter) {
      var searchTxt = (filter || '').toUpperCase();
      if (searchTxt) {
        items = _.filter(items, function (item) {
          return !!_.find(item.cells, function (m) {
            if (m.column.name != "actions") {
              if (m.content && m.content.toUpperCase().indexOf(searchTxt) > -1) {
                return true;
              }
            }
          });
        });
      }
      return items;
    }
  }, {
    requiredFeature: 'reporting',
    requiredPermissions: ['RUN_REPORT']
  });
  return AuditReportingController;
});

